// extracted by mini-css-extract-plugin
export default {"regular":"Button_regular__dAYPY","regularDisabled":"Button_regularDisabled__Kn5TZ"};